import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { DefaultListElementBase } from '../components';
export var defaultListElementBaseTopModelsObject = {
    ElementBase: React.createElement(TopModel, { name: "ElementBase" }, DefaultListElementBase),
};
